import { render } from "./RolesInput.vue?vue&type=template&id=053305ad"
import script from "./RolesInput.vue?vue&type=script&lang=js"
export * from "./RolesInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__